import { useState } from "react";
import axios from "axios";
import config from "../Config";
import { createContainer } from "unstated-next";

const api = axios.create({
  baseURL: config.API_URL,
  timeout: 10000,
  headers: { source: "customer" },
});

const useOTPHandler = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [errCode, setErrCode] = useState("");

  const [customerToken, setCustomerToken] = useState("")
  const [userToken, setUserToken] = useState("")

  let sendOTP = async () => {
    return await api.post(`/auth/phone-email-otp`, {
      login: mobileNumber,
    });
  };


  let verifyOTP = async (otp: string) => {
    try {
      const { data } = await api.post(`/auth/verify-otp`, {
        phone_no: mobileNumber,
        otp_code: otp,
      });

      if (data && data.isSuccess) {
        if (data.data.has_profile) {
          window.location.href = `${config.WEMOVE_APP_URL}/login/${data.data.customToken}`;
        } else {
          setCustomerToken(data.data.customToken)
          return 412;
        }
      }
    } catch (error) {
      setErrCode("Invalid OTP code, try again.");
      return 0;
    }
  };

  let verifyLogin = async (otp: string) => {
    try {
      const { data } = await api.post(`/auth/verify-login`, {
        login: mobileNumber,
        otp_code: otp,
      });

      if (data && data.isSuccess) {
        if (data?.data?.has_profile) {
          window.location.href = `${config.JRMALL_URL}/login/joyRideAuth/${data.data.token}`;
        } else {
          setCustomerToken(data.data.token)
          return 412;
        }
      }
    } catch (error) {
      setErrCode("Invalid OTP code, try again.");
      return 0;
    }
  };

  let register = async (user: any) => {
    try {
      const apiAuth = axios.create({
        baseURL: config.API_URL,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });


      let {data} = await apiAuth.put(`/auth/user-profiles`, {
        firstname: user.firstName,
        lastname: user.lastName,
        email: user.userMailID
      });

      return data.isSuccess? true: false
    } catch (error) {
      setErrCode("Registration failed.");

      return false;
    }
  };

  return {
    customerToken,
    errCode,
    mobileNumber,
    setMobileNumber,
    sendOTP,
    verifyOTP,
    register,
    verifyLogin,
    setErrCode,
    setUserToken,
    userToken,
  };
};

export default createContainer(useOTPHandler);
